import { makeStyles } from "@material-ui/core/styles";

const blumiraBlue = "#3E7EF8";

export const loginViewStyles = makeStyles((theme) => ({
  textField: {
    width: "100%",
    [`& .MuiInput-root`]: {
      borderRadius: "0px 3px 3px 0px",
      padding: 0,
    },
    [`& input`]: {
      paddingLeft: "10px",
    },
    [`& .MuiInputBase-root`]: {
      borderRadius: "0p 3p 3px 0px",
      borderColor: "#f1f1f1",
      "&.Mui-focused": {
        borderColor: "#a1a1a1",
      },
      "&.Mui-error": {
        borderColor: "#E76F51",
      },
    },
  },
  headerMsg: {
    marginTop: 10,
    fontWeight: 400,
    fontSize: "16px",
    whiteSpace: "pre-line",
  },
  createAccountButton: {
    width: 300,
    height: 60,
    fontSize: 16,
    fontWeight: "bold",
    textTransform: "none",
    color: theme.palette.background.paper,
    backgroundColor: blumiraBlue,
    "&:hover": {
      backgroundColor: blumiraBlue,
    },
  },
  continueButton: {
    height: 40,
    width: "100%",
    marginTop: 15,
    fontWeight: 500,
    marginBottom: 30,
    textTransform: "none",
    backgroundColor: blumiraBlue,
    color: theme.palette.background.paper,
    "&:hover": {
      backgroundColor: blumiraBlue,
    },
  },
  dialogContent: {
    width: 350,
    display: "flex",
    textAlign: "center",
    alignItems: "center",
    flexDirection: "column",
    padding: "15px 30px 30px 30px",
    justifyContent: "space-between",
  },
  dialogHeaderContainer: {
    display: "flex",
    paddingRight: 15,
    alignItems: "center",
    justifyContent: "space-between",
  },
  closeIcon: {
    cursor: "pointer",
    color: theme.palette.text.secondary,
  },
  draftsIcon: {
    fontSize: 80,
    color: theme.palette.text.secondary,
  },
  logoImage: {
    width: "100%",
    minWidth: 200,
    maxWidth: 300,
  },
  primarySuccessText: {
    fontSize: 15,
  },
  ctaSuccessText: {
    color: blumiraBlue,
    cursor: "pointer",
  },
  signupDialogDivider: {
    width: "100%",
  },
  microsoftLogoContainer: {
    paddingTop: 30,
    display: "flex",
    justifyContent: "center",
  },
  microsoftLogo: {
    height: 18,
  },
  microsoftTitleText: {
    paddingLeft: 10,
  },
  microsoftPrimaryText: {
    fontWeight: "bold",
  },
  microsoftSecondaryText: {
    margin: 0,
    color: theme.palette.text.secondary,
  },
}));
